import * as React from 'react';
import { useReducer, useEffect, useRef, useContext } from 'react';

import { AppUserInfo, UserProfile } from "../../models/index";
import { UserELP } from '../../models/UserELP';
import UserELPService from '../../services/UserELPService';
import AuthenticationContext from '../../components/context/AuthenticationContext';
import { Button } from 'reactstrap';


const PAGE_SIZE = 10;

type AEState = {
    aeData: UserELP
}

export const ELPDashboard = (props: {
    userProfile?: UserProfile
}) => {

    const authCtx = useContext(AuthenticationContext);

    let [state, setState] = useReducer(
        (prevState: AEState, newState: Partial<AEState>) => ({ ...prevState, ...newState }),
        {
            aeData: new UserELP()
        }
    );

    const getAEs = async () => {

        let ae = await UserELPService.get();
        if (props.userProfile) {
            ae = await UserELPService.getELP(props.userProfile.userProfileId);
        }

        if (ae) {
            setState({
                aeData: ae.value
            })
            console.log('AE IS', ae);
        }
    }

    useEffect(() => {
        getAEs();
    }, []);

    return <div className="mb-4">
        {state.aeData && state.aeData.elp != null &&
            <div className="border border-2 rounded p-2 mt-4">
                <h3>English Language Proficiency</h3>
                <div className="mt-2">
                    <div>ELP Status 1: <strong>{state.aeData.elp}</strong></div>
                    ELP Decision Letter 1:<br />
                    <em>{state.aeData.userLetter1}</em>
                </div>

                {state.aeData.hasAE2 &&
                    <div className="mt-2">
                        <div>ELP Status 2: <strong>{state.aeData.elp2}</strong></div>
                        ELP Decision Letter 2:<br />
                        <em>{state.aeData.userLetter2}</em>
                    </div>
                }

                {state.aeData.hasAE3 &&
                    <div className="mt-2">
                        <div>ELP Status 3: <strong>{state.aeData.elp3}</strong></div>
                        ELP Decision Letter 3:<br />
                        <em>{state.aeData.userLetter3}</em>
                    </div>
                }
            </div>
        }
    </div>
};